import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Form, Input } from '~/components/Form';
import { t } from '~/helpers';
import { storeData, updateData } from '~/store/modules/corredor/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.corredor);

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        nomecorredor: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param
      };

      if (create) {
        await dispatch(storeData(objSend, params));
      } else {
        await dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="nomecorredor"
            label={t('Nome Corredor')}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
